/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "button_colors_default": "",
  "button_size_default": "",
  "button_variant_default": "",
  "loader_animation_default": "",
  "loader_colors_default": "",
  "loader_size_default": "",
  "loader_variant_default": "",
  "colors_default": "",
  "size_default": "mx-auto my-10",
  "variant_default": "flex justify-center"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "ScrollPageControls");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;